import { Button } from "@pepperstone/pepper-ui-kit";
import clsx from "clsx";
import type React from "react";
import { Trans, useTranslation } from "react-i18next";
import { SupportLink } from "@/components/SupportLink";
import style from "./ErrorPage.module.css";
import { EIcon } from "@/utils/enums";
import { Icon } from "../general/icon/Icon";

type ErrorPageProps = {
  title?: string;
  message?: React.ReactNode;
  icon?: EIcon;
  showButton?: boolean;
  buttonLabel?: string;
  buttonAction?: () => void;
  className?: string;
};

export const ErrorPage = ({
  title,
  message,
  icon = EIcon.GeneralError,
  showButton = true,
  buttonLabel,
  buttonAction,
  className,
}: ErrorPageProps) => {
  const { t } = useTranslation();

  title = title ?? t("global.error_page.unable_to_load_information");
  message = message ?? (
    <Trans
      i18nKey="global.error_page.retry_or_contact_support"
      components={{ supportLink: <SupportLink /> }}
    />
  );

  return (
    <div className={clsx(style.wrapper, className)} data-testid="error-page">
      <div className={style["icon-container"]}>
        <Icon name={icon} />
      </div>
      <div className={style.container}>
        <h2 className={style.h2} data-testid="error-page-title">
          {title}
        </h2>
        <p className={style.message}>{message}</p>
      </div>
      {showButton && (
        <div>
          <Button
            type="button"
            size="ps-btn-lg"
            variant="ps-btn-primary"
            onClick={buttonAction}
          >
            {buttonLabel ?? t("global.buttons.retry")}
          </Button>
        </div>
      )}
    </div>
  );
};
